<template>
  <div>
    <el-pagination :page-size="PageSize"
                   class="page"
                   background
                   :current-page="PageIndex"
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    PageSize: {
      type: Number,
      default: 0
    },
    PageIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },
    handleDelete (deleteCount) {
      deleteCount = deleteCount || 1
      let curTotal = this.total - deleteCount
      if (this.PageIndex * this.PageSize > curTotal) {
        if (curTotal > 0) {
          curTotal = curTotal - 1
        }
        let index = parseInt(curTotal / this.PageSize) + 1
        this.handleCurrentChange(index)
      } else {
        this.handleCurrentChange(this.PageIndex)
      }
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
</style>
